import { Component, input, output } from '@angular/core';
import {
  BatchUploadConfig,
  BatchUploadModalComponent,
} from '@shared/components/batch-upload-modal/batch-upload-modal.component';

@Component({
  selector: 'app-batch-upload-unit-target',
  imports: [BatchUploadModalComponent],
  template: `
    <app-batch-upload-modal
      [isVisible]="isVisible()"
      [config]="uploadConfig"
      (isVisibleChange)="isVisibleChange.emit($event)"
    ></app-batch-upload-modal>
  `,
})
export class BatchUploadUnitTargetComponent {
  readonly isVisible = input<boolean>(false);
  readonly isVisibleChange = output<boolean>();

  uploadConfig: BatchUploadConfig = {
    title: '批量修改高级定向',
    templateUrl:
      'https://static-cdn.linkworld.cn/xiaohong/红品智-推广-批量修改高级定向模板_2026-10-15.xlsx',
    type: 15,
    description: '1、下载批量修改高级定向模板，批量填写高级定向信息',
  };
}
